import { DocumentServiceFactory } from '@/resources/factory';

const inventoryDocumentService = new DocumentServiceFactory({
  getAll: 'api/PartDocument/:id',
  uploadFiles: 'api/PartDocument/uploadfiles/:id',
  deleteDocument: 'api/PartDocument/:id',
  openDocument: 'api/PartDocument/download?fileId=:id'
});

export default inventoryDocumentService;
